import { memo, type ReactNode } from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import { cn } from '@/lib/utils'

import type { DataTableCheckboxProps } from './data-table.interface'

const DataTableCheckboxBase: React.FC<DataTableCheckboxProps> = ({
  isChecked,
  onCheckedChange,
  isDisabled = false,
  ariaLabel,
  className,
}): ReactNode => (
  <Checkbox
    checked={isChecked}
    onCheckedChange={onCheckedChange}
    disabled={isDisabled}
    aria-label={ariaLabel}
    className={cn('data-table-checkbox', className)}
  />
)

export const DataTableCheckbox = memo(DataTableCheckboxBase)

DataTableCheckbox.displayName = 'DataTableCheckbox'
